// extracted by mini-css-extract-plugin
export var actions = "_ne-5";
export var assistantBubble = "_ne-3";
export var assistantRow = "_ne-6";
export var bubble = "_ne-0";
export var humanAvatar = "_ne-4";
export var inlineToolCard = "_ne-1";
export var userBubble = "_ne-2";